"use strict";

exports.__esModule = true;
exports.EnhancedContextLoader = EnhancedContextLoader;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function EnhancedContextLoader(props) {
  var Context = props.Context,
    children = props.children;
  var contextValue = _react["default"].useContext(Context);
  if (contextValue) {
    return children;
  }
  return /*#__PURE__*/_react["default"].createElement(Context.Provider, null, children);
}